import { gsap } from 'gsap';

/**
 * Live Watch Listing AI Due-Diligence Analyzer Tool
 */
export function initLiveAnalyzer() {
  const analyzerForm = document.getElementById('analyzer-form');
  const urlInput = document.getElementById('analyzer-url');
  const presetBtns = document.querySelectorAll('.analyzer-preset-btn');
  const progressBox = document.getElementById('analyzer-progress');
  const progressBar = document.getElementById('analyzer-progress-bar');
  const progressStepText = document.getElementById('analyzer-step-text');
  const reportBox = document.getElementById('analyzer-report');

  if (!analyzerForm || !urlInput) return;

  // Presets click
  presetBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const url = btn.getAttribute('data-url');
      if (url) urlInput.value = url;
    });
  });

  const STEPS = [
    'Parsing listing metadata & OCR description...',
    'Scanning high-res photos for lug chamfer polish & bezel alignment...',
    'Cross-referencing 92,000 stolen serial number records...',
    'Evaluating seller transaction volume & duplicate listings...',
    'Calculating landed customs duty, shipping, and fair market value...'
  ];

  analyzerForm.addEventListener('submit', (e) => {
    e.preventDefault();

    if (!urlInput.value.trim()) return;

    // Show Progress Box, Hide Report
    progressBox.style.display = 'block';
    reportBox.style.display = 'none';

    let currentStep = 0;
    progressBar.style.width = '0%';

    function runStep() {
      if (currentStep < STEPS.length) {
        progressStepText.textContent = STEPS[currentStep];
        const pct = Math.round(((currentStep + 1) / STEPS.length) * 100);

        gsap.to(progressBar, {
          width: `${pct}%`,
          duration: 0.6,
          ease: 'power2.out',
          onComplete: () => {
            currentStep++;
            setTimeout(runStep, 400);
          }
        });
      } else {
        // Complete! Show Report Card
        setTimeout(() => {
          progressBox.style.display = 'none';
          reportBox.style.display = 'block';

          gsap.fromTo(reportBox, 
            { opacity: 0, y: 20 }, 
            { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' }
          );
        }, 300);
      }
    }

    runStep();
  });
}
